import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './styles/index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import WhyCVEarity from './components/WhyCVEarity';
import ProcessStepper from './components/ProcessStepper';
import CVELookup from './components/CVELookup';
import SecurityNews from './components/SecurityNews';
import FAQ from './components/FAQ';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={
          <main>
            <Hero />
            <TrustBar />
            <WhyCVEarity />
            <ProcessStepper />
            <CVELookup />
            <SecurityNews />
            <FAQ />
            <ContactCTA />
          </main>
        } />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      </Routes>
      <Footer />
    </>
  );
}
